export const appConfig = {
  web3formsAccessKey: '3bf74860-5cf8-4313-b5af-243f5d064987',
  appName: 'Jai Ambe Herbs & Spices',
  appDescription: 'Jai Ambe Herbs & Spices is a company that supplies premium quality herbs, spices, and oils.',
  appKeywords: ['Jai Ambe Herbs & Spices', 'Herbs', 'Spices', 'Oils'],
  appAuthor: 'Jai Ambe Herbs & Spices',
  appAuthorEmail: 'jaiambeherbs2025@gmail.com',
  appAuthorWebsite: 'https://jaiambeherbs.com',
  appAuthorPhone: '+91 91656 55391',
  secodaryContactNumber: '+91 79877 09383',
  appAuthorAddress: 'Neemuch, Madhya Pradesh, India',
}